<template>
  <transition :name="`ui-drawer-${placement}`">
    <div v-if="modelValue" class="ui-drawer" :style="{ zIndex }" @click="handleBackdrop">
      <div class="ui-drawer__content" :class="`ui-drawer__content--${placement}`" @click.stop>
        <slot :close="close" />
        <slot name="close" :close="close" />
      </div>
    </div>
  </transition>
</template>

<script setup>
// 通用抽屉外壳: 点遮罩关闭 + slide 过渡 + z-index 统一
// v-model:modelValue 控制显隐, 关闭走 emit('update:modelValue', false)
// 内容尺寸由业务组件通过 slot 内 DOM 自定, close 按钮走具名 slot 拿 close 函数
defineOptions({ name: 'UiDrawer' })

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  placement: {
    type: String,
    default: 'bottom',
    validator: v => ['bottom', 'top', 'left', 'right'].includes(v)
  },
  zIndex: { type: Number, default: 50 },
  closeOnBackdrop: { type: Boolean, default: true }
})

const emit = defineEmits(['update:modelValue'])

function close() {
  emit('update:modelValue', false)
}
function handleBackdrop() {
  if (props.closeOnBackdrop) close()
}
</script>

<style lang="scss" scoped>
.ui-drawer {
  position: fixed;
  inset: 0;
}

.ui-drawer__content {
  position: absolute;

  &--bottom { bottom: 0; left: 0; width: 100%; }
  &--top    { top: 0;    left: 0; width: 100%; }
  &--left   { top: 0;    left: 0; height: 100%; }
  &--right  { top: 0;    right: 0; height: 100%; }
}

// 对齐 enter 400ms / leave 300ms
%enter { transition: transform 400ms ease-out; }
%leave { transition: transform 300ms ease-out; }

.ui-drawer-bottom-enter-active,
.ui-drawer-top-enter-active,
.ui-drawer-left-enter-active,
.ui-drawer-right-enter-active { @extend %enter; }

.ui-drawer-bottom-leave-active,
.ui-drawer-top-leave-active,
.ui-drawer-left-leave-active,
.ui-drawer-right-leave-active { @extend %leave; }

.ui-drawer-bottom-enter-from, .ui-drawer-bottom-leave-to { transform: translateY(100%); }
.ui-drawer-top-enter-from,    .ui-drawer-top-leave-to    { transform: translateY(-100%); }
.ui-drawer-left-enter-from,   .ui-drawer-left-leave-to   { transform: translateX(-100%); }
.ui-drawer-right-enter-from,  .ui-drawer-right-leave-to  { transform: translateX(100%); }
</style>
